import { Button } from "@sellar-io/components";
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import {
  isSignInConnectionError,
  signInConnectionMessage,
} from "../../../hooks/signInConnection";
import { useState } from "react";
import { Alert } from "~/components/alert/Alert";
import { useFirebaseUser } from "~/hooks/useFirebaseUser.shared";

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ hd: "sellar.io" });

const googleEmployeeSignInEnabled = ["development", "staging"].includes(
  import.meta.env.VITE_ENV,
);

export function GoogleEmployeeSignInButton() {
  const { auth } = useFirebaseUser();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);

  if (!googleEmployeeSignInEnabled) return null;

  const signIn = async () => {
    if (loading) return;
    setError(undefined);
    setLoading(true);

    try {
      const { user } = await signInWithPopup(auth, googleProvider);
      const isSellarEmployee =
        user.emailVerified && user.email?.toLowerCase().endsWith("@sellar.io");

      if (!isSellarEmployee) {
        await signOut(auth);
        setError("Sign in with a verified Sellar Google account.");
        return;
      }
    } catch (error) {
      setError(
        isSignInConnectionError(error)
          ? signInConnectionMessage
          : "Google sign-in was unsuccessful. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3 text-zinc-500">
        <div className="h-px flex-1 bg-zinc-200" />
        <span className="text-xs font-medium uppercase">Sellar employees</span>
        <div className="h-px flex-1 bg-zinc-200" />
      </div>
      {error && <Alert type="error" message={error} />}
      <Button
        className="w-full"
        color="secondary"
        loading={loading}
        disabled={loading}
        onClick={signIn}
      >
        <span>Continue with Google</span>
      </Button>
    </div>
  );
}
